import { Box, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import OpeningHourDto from "../../models/OpeningHourDto";

interface OpeningHourProps {
    openingHour: OpeningHourDto;
}

export default function OpeningHour({ openingHour }: OpeningHourProps) {
    return (
        <>
            {
                openingHour.from && openingHour.to &&
                <Grid2 xs={openingHour.value.length ? 5 : 12} key={'hour_' + openingHour.id}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }} >
                        <Grid2 xs={'auto'}>
                            <Typography>{openingHour.from.substring(0, openingHour.from.lastIndexOf(':'))}</Typography>
                        </Grid2>
                        <Grid2 xs={'auto'}>
                            <Typography>{'-'}</Typography>
                        </Grid2>
                        <Grid2 xs={'auto'} >
                            <Typography>{openingHour.to.substring(0, openingHour.to.lastIndexOf(':'))}</Typography>
                        </Grid2>
                    </Box>
                </Grid2>
            }
            <Grid2 xs={openingHour.from && openingHour.to ? 7 : 12} key={'text_' + openingHour.id} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ textAlign: 'center', minWidth: '100%' }}>
                    {openingHour.value.length ? openingHour.value : !openingHour.from ? '-' : ''}
                </Typography>
            </Grid2>
        </>
    );
}